import { css } from 'styled-components';
import filerImageHover from 'images/ProfileImageFilerHover.png';

const hoverStyles = (image: any) => {
  if (image) {
    return `
      background-image: url(${image});
      :after {
        display: none;
      }
    `;
  }
  return `
    background-image: url(${filerImageHover});
    :after {
      display: none;
    }
  `;
};

const AvatarPhoto = css`
  border-color: ${({ theme }) => theme.colors.white};

  &:hover {
    ${({ image }: any) => hoverStyles(image)};
  }
`;

export default AvatarPhoto;
